import { Component, Inject } from '@angular/core';
import { ClientEnvironment, ENVIRONMENT } from '@thehubz/client/core';

@Component({
  selector: 'lh-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  readonly version?: string;
  appLogoUrl!: string;

  constructor(@Inject(ENVIRONMENT) readonly env: ClientEnvironment) {
    this.version = `${env.environment !== 'LIVE' ? env.environment : ''} ${env.appVersion}`;
  }
}
